<template>
  <v-dialog
    :model-value="modelValue"
    max-width="420"
    scrollable
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card
      class="color-picker-dialog"
      rounded="xl"
    >
      <v-card-title class="color-picker-dialog__header px-5 pt-5 pb-2">
        <span class="color-picker-dialog__icon">
          <v-icon size="20">mdi-palette-outline</v-icon>
        </span>
        <span class="text-h6">{{ title }}</span>
      </v-card-title>
      <v-card-text class="px-5 pt-3">
        <ColorPicker
          :value="draftColor"
          @update:value="emit('update:draftColor', $event)"
        />
        <div
          id="color-picker-dialog-error"
          aria-live="polite"
        >
          <v-alert
            v-if="errorMessage"
            type="error"
            variant="tonal"
            density="compact"
            rounded="lg"
            class="mt-4 text-body-2"
          >
            {{ errorMessage }}
          </v-alert>
        </div>
      </v-card-text>
      <v-card-actions class="px-5 pb-5 pt-1">
        <v-spacer />
        <v-btn
          variant="text"
          rounded="lg"
          @click="emit('cancel')"
        >
          {{ $t('labels.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          rounded="lg"
          :disabled="saveDisabled"
          :aria-describedby="errorMessage ? 'color-picker-dialog-error' : undefined"
          @click="onSave"
        >
          {{ $t('labels.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import ColorPicker from '@/components/ColorPicker.vue'

const props = withDefaults(
  defineProps<{
    modelValue: boolean
    title: string
    draftColor: string
    errorMessage?: string | null
    saveDisabled?: boolean
  }>(),
  {
    errorMessage: null,
    saveDisabled: false,
  }
)

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  'update:draftColor': [hex: string]
  cancel: []
  save: []
}>()

function onSave() {
  if (props.saveDisabled) return
  emit('save')
}
</script>

<style scoped>
.color-picker-dialog {
  overflow: hidden;
}

.color-picker-dialog__header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-picker-dialog__icon {
  display: grid;
  width: 36px;
  height: 36px;
  place-items: center;
  border-radius: 10px;
  background: rgba(var(--v-theme-primary), 0.1);
  color: rgb(var(--v-theme-primary));
}
</style>
